import React, { useContext } from 'react';
import Contact from './Contact';
import ContactHeader from './ContactHeader';
import NavigationMobile from '../navigation/NavigationMobile';
import { BaseContext } from '../contexts/baseContext';

import photo from '../../docs/nature2.png';

export default function ContactInterface({ discussions }) {
  const { contactBodyHeight } = useContext(BaseContext);

  return (
    <>
      <ContactHeader />

      <div className="section-contacts-body" style={{ height: `${contactBodyHeight}px` }}>
        {
          discussions.map(discussion => {
            let contact = {...discussion.contact};
            contact.photo = photo;

            let length = discussion.messages.length-1;
            let lastMessage = discussion.messages[length];

            return (
              <Contact
                contact={contact}
                message={lastMessage}
                active={discussion.active}
                key={contact.id}
              />
            )
          })
        }
      </div>

      <NavigationMobile />
    </>
  )
}
